import axios from "../http";

class User {
  //用户登录
  postUserLogin(data) {
    const url = "/oa/api/login/manager";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //用户退出登录
  postUserLogout() {
    const url = "/oa/api/auth/logout";
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 信鸽退出登录
  postCustomerUserLogout() {
    const url = "/oa/api/pc/customer/login/out";
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 获取登录信息
  getLoginInfo() {
    const url = "/oa/api/pc/manager/current";
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default User;
